export const MuiListItem = (palette) => ({
  root: {
    'height': 'auto',
    'min-height': '24px',
    'flex-direction': 'column',
    'align-items': 'flex-start',
    'justify-content': 'center',
    '&:hover': {
      'background-color': palette.primary.light,
    },
    '&$selected': {
      'background-color': palette.primary.light,
    },
    '&$gutters': {
      padding: '8px 24px',
    },
    '& a': {
      color: '#393a3b',
      textDecoration: 'none',
    },
  },
})
